import Phaser from 'phaser';
import { AudioKey, AudioKeys } from '../config/keys';

const STORAGE_KEY = 'flappy-stick-bird:muted';

export class AudioManager {
  private static instance: AudioManager | undefined;
  private scene: Phaser.Scene;
  private muted: boolean;
  private availableSounds = new Set<AudioKey>();

  private constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.muted = localStorage.getItem(STORAGE_KEY) === 'true';
  }

  static get(scene: Phaser.Scene): AudioManager {
    if (!AudioManager.instance) {
      AudioManager.instance = new AudioManager(scene);
    }

    AudioManager.instance.scene = scene;
    return AudioManager.instance;
  }

  registerLoadedSounds(): void {
    Object.values(AudioKeys).forEach((key) => {
      if (this.scene.cache.audio.exists(key)) {
        this.availableSounds.add(key);
      }
    });
  }

  play(key: AudioKey, config?: Phaser.Types.Sound.SoundConfig): Phaser.Sound.BaseSound | undefined {
    if (this.muted || !this.availableSounds.has(key)) {
      return;
    }

    const sound = this.scene.sound.add(key, {
      volume: 0.75,
      ...config,
    });
    sound.play();

    return sound;
  }

  stop(key: AudioKey): void {
    if (!this.availableSounds.has(key)) {
      return;
    }

    this.scene.sound.stopByKey(key);
  }

  toggleMuted(): boolean {
    this.muted = !this.muted;
    localStorage.setItem(STORAGE_KEY, String(this.muted));
    return this.muted;
  }

  isMuted(): boolean {
    return this.muted;
  }
}
